module.exports = __webpack_public_path__ + "static/media/Chearing_Group_right.23ebc46b.png";